import React from "react";
import "./style.css";
import Card from "./Card";
import { AnimatePresence } from "framer-motion";
import ScrollTopButton from "./ScrollTopButton";

const Ucarlist = ({ ucarSerchData }) => {
  return (
    <>
      <AnimatePresence>
        <div className='ucarList'>
          {ucarSerchData.map((ucar) => {
            return <Card key={ucar.zaiko_id} ucar={ucar} />;
          })}
        </div>
      </AnimatePresence>
      <ScrollTopButton />
    </>
  );
};

export default Ucarlist;
